import React, { useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useForm, useWatch } from 'react-hook-form';
import SingleDatePicker from '../../../components/form/SingleDatePicker';
import DocumentTypeSelect from '../../../components/form/DocumentTypeSelect';
import EInvoiceTypeSelect from '../../../components/form/EinvoiceTypeSelect';

const DocumentFilters = ({ onGenerateReport, isLoading }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      eInvoiceType: null,
      documentType: null,
      startDate: null,
      endDate: null,
    },
  });
  const startDate = useWatch({ control, name: 'startDate' });
  const endDate = useWatch({ control, name: 'endDate' });
  const eInvoiceType = useWatch({ control, name: 'eInvoiceType' });
  const documentType = useWatch({ control, name: 'documentType' });

  const canGenerate = useMemo(() => !!startDate && !!endDate && !!eInvoiceType, [startDate, endDate, eInvoiceType]);

  const handleGenerate = (data) => {
    const formattedData = {
      ...data,
      eInvoiceType: data.eInvoiceType?.value || null,
      documentType: data.documentType?.value || null,
      startDate: data.startDate ? data.startDate.format('YYYY-MM-DD') : null,
      endDate: data.endDate ? data.endDate.format('YYYY-MM-DD') : null,
    };
    onGenerateReport(formattedData);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(handleGenerate)}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid container spacing={2} size={10} justifyContent="flex-start">
          <Grid item xs={6} sm={18} sx={{ width: '230px' }}>
            <EInvoiceTypeSelect name="eInvoiceType" control={control} errors={errors} />
          </Grid>

          {(!eInvoiceType || eInvoiceType?.value !== 'aiExtraction') && (
            <Grid item xs={12} sm={4} sx={{ width: '230px' }}>
              <DocumentTypeSelect name="documentType" control={control} errors={errors} />
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <SingleDatePicker
              control={control}
              name="startDate"
              label="Start Date"
              errors={errors}
              minDate={endDate ? endDate.subtract(1, 'year') : null}
              maxDate={endDate && endDate.isBefore(dayjs()) ? endDate : dayjs()}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <SingleDatePicker
              control={control}
              name="endDate"
              label="End Date"
              errors={errors}
              minDate={startDate ? startDate : null}
              maxDate={startDate && startDate.add(1, 'year').isBefore(dayjs()) ? startDate.add(1, 'year') : dayjs()}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={3} container justifyContent="flex-end" alignItems="center">
          <Button id="generate-report" type="submit" variant="contained" fullWidth disabled={!canGenerate || isLoading}>
            {isLoading ? 'Generating...' : 'Generate Report'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default DocumentFilters;
